import { IFramedComponent } from 'components/IFramedComponent';
import { useAuth } from 'contexts/authContext';
import { matchPath, Outlet, useLocation } from 'react-router-dom';
import { Navbar } from 'root/Navbar';
import { iframePaths, reactPaths } from 'root/pathnames';
import { Main, MainContainer, PageLayout, PageWrap } from './MainLayout.css';

const matchPathToIframeRoutes = (pathnameToCheck: string) =>
  Object.values(iframePaths).some(
    (pattern) => !!matchPath(pattern, pathnameToCheck),
  );

const isTransportCloudPage = (pathname: string) =>
  !!matchPath(
    { path: `${reactPaths.transportCloud}/*`, end: false },
    pathname,
  ) || pathname === reactPaths.transportCloud;

export function MainLayout() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const isIframeHidden = !matchPathToIframeRoutes(pathname);
  const isTransportCloud = isTransportCloudPage(pathname);

  return (
    <MainContainer>
      <Navbar user={user} />
      <Main isTransportCloud={isTransportCloud}>
        <PageWrap isHidden={!isIframeHidden} disableOverflow={isTransportCloud}>
          <PageLayout isTransportCloud={isTransportCloud}>
            <Outlet />
          </PageLayout>
        </PageWrap>
        <PageWrap isHidden={isIframeHidden}>
          <IFramedComponent pathname={pathname} isHidden={isIframeHidden} />
        </PageWrap>
      </Main>
    </MainContainer>
  );
}
